import { createI18nProperty } from '@/i18n'
import Index from './index.vue'
import Detail from './detail.vue'
import DashboardIndex from './dashboard'
import TaskEditor from './taskEditor'
import EmailResumeDetail from './emailResumeDetail.vue'

const basePath = '/v-admin/rpa'

export default {
  name: 'rpaDashboardLayout',
  path: `${basePath}`,
  component: Index,
  redirect: `${basePath}/index`,
  meta: {
    isInclude: true,
    permission: ['PERM_RPA_MANAGEMENT', 'PREMIUM_RPA_MANAGEMENT'],
    rootLayout: {
      autosize: true
    },
    titleI18nKey: 'RPA',
    tab: createI18nProperty({
      contentStyle: {
        background: '#f7f7f7',
        padding: '40px'
      }
    }, 'label', 'admin.rpa.tab')
  },
  children: [
    {
      name: 'rpaNewDashboardIndex',
      path: `${basePath}-new/index`,
      component: DashboardIndex,
      props: { taskBackend: 'new' },
      meta: { titleI18nKey: 'admin.rpa.title.index' }
    },
    {
      name: 'rpaNewTaskDetail',
      path: `${basePath}-new/task/:taskId/detail`,
      component: Detail,
      props: { taskBackend: 'new' },
      meta: { titleI18nKey: 'admin.rpa.title.task.detail' }
    },
    {
      name: 'rpaNewEditTask',
      path: `${basePath}-new/task/:taskId/edit`,
      component: TaskEditor,
      props: { taskBackend: 'new' },
      meta: { isEditMode: true, titleI18nKey: 'admin.rpa.title.Task.edit' }
    },
    {
      name: 'rpaDashboardIndex',
      path: `${basePath}/index`,
      component: DashboardIndex,
      meta: {
        titleI18nKey: 'admin.rpa.title.index'
      }
    },
    {
      name: 'rpaTaskDetail',
      path: `${basePath}/task/:taskId/detail`,
      component: Detail,
      meta: {
        titleI18nKey: 'admin.rpa.title.task.detail'
      }
    },
    {
      name: 'rpaAddTask',
      path: `${basePath}/task/add`,
      component: TaskEditor,
      meta: {
        isEditMode: false,
        titleI18nKey: 'admin.rpa.title.task.add'
      }
    },
    {
      name: 'rpaEditTask',
      path: `${basePath}/task/:taskId/edit`,
      component: TaskEditor,
      meta: {
        isEditMode: true,
        titleI18nKey: 'admin.rpa.title.Task.edit'
      }
    },
    {
      path: `${basePath}/email-resume/:taskId/detail`,
      component: EmailResumeDetail,
      meta: {
        titleI18nKey: 'admin.rpa.title.task.detail'
      }
    }
  ]
}
